import ChangeProgramCampusModalityDataStore from '../../datastores/ChangeProgramCampusModalityDataStore';

export default class ChangeProgramCampusModalityDataStoreGraphQL
  implements ChangeProgramCampusModalityDataStore
{
  async registerChangeAcademicData() {
    const data = {
      registerChangeAcademicData: {
        error: '',
        requestId: 10
      }
    };
    return data.registerChangeAcademicData;
  }

  async activateChangeAcademicData() {
    const data = {
      activateChangeAcademicData: {
        error: '',
        requestId: 1
      }
    };
    return data;
  }

  async cancel() {
    const data = {
      cancelChangePhotoRequestProcedure: {
        error: '',
        requestId: 1
      }
    };
    return data;
  }
}
